import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { readTenantIdFromJwt } from '../utils/jwt.util';
import { User } from '../user';
import { AuthService } from '../auth.service';
import { LocalStorageService } from '../services/local-storage.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm : FormGroup;
  hide = true;
  constructor(private _authService:AuthService, private _router: Router, private tokenStorage: LocalStorageService) { }
  user = new User();
  msg = '';

  ngOnInit(){
    this.loginForm = new FormGroup({
      username : new FormControl('',[Validators.required]),
      password : new FormControl('', [Validators.required, Validators.minLength(6)])
    });

  }

  loginUser() {
    this._authService.loginUserFromRemote(this.user).subscribe(

      data => {
        this.tokenStorage.saveToken(data.token);
        this.tokenStorage.saveRole(data.role);
        const school = this.pickSchoolName(data);
        this.tokenStorage.saveSchoolDisplayName(school);
        const tenantFromBody = this.pickTenantId(data);
        const tenantFromJwt = readTenantIdFromJwt(data.token);
        const tenantId = tenantFromBody != null ? tenantFromBody : tenantFromJwt;
        if (tenantId != null) {
          this.tokenStorage.saveTenantId(tenantId);
        }
        const userPayload = this.buildUserPayload(data, tenantId);
        if (userPayload) {
          this.tokenStorage.saveUser(userPayload);
        }
        this._router.navigate(['/home/dashboard']);
      },
      error => {
        this.msg = "Bad credentials!!";
      }
    );
  }

  private pickSchoolName(data: Record<string, unknown>): string {
    const keys = ['schoolName', 'tenantName', 'organizationName', 'institutionName'];
    for (const k of keys) {
      const v = data[k];
      if (typeof v === 'string' && v.trim()) {
        return v.trim();
      }
    }
    const school = data['school'];
    if (school && typeof school === 'object') {
      const name = (school as Record<string, unknown>)['name'];
      if (typeof name === 'string' && name.trim()) {
        return name.trim();
      }
    }
    if (typeof data['school'] === 'string' && (data['school'] as string).trim()) {
      return (data['school'] as string).trim();
    }
    return environment.schoolName;
  }

  private pickTenantId(data: Record<string, unknown>): number | null {
    const keys = ['tenantId', 'schoolId', 'tenant_id', 'school_id'];
    for (const k of keys) {
      const v = data[k];
      if (typeof v === 'number' && !Number.isNaN(v)) {
        return v;
      }
      if (typeof v === 'string' && /^\d+$/.test(v)) {
        return Number(v);
      }
    }
    const school = data['school'];
    if (school && typeof school === 'object') {
      const id = (school as Record<string, unknown>)['id'];
      if (typeof id === 'number' && !Number.isNaN(id)) {
        return id;
      }
      if (typeof id === 'string' && /^\d+$/.test(id)) {
        return Number(id);
      }
    }
    return null;
  }

  private buildUserPayload(data: Record<string, unknown>, tenantId: number | null): Record<string, unknown> | null {
    const username =
      (typeof data['username'] === 'string' && data['username']) ||
      this.user.username ||
      null;
    if (!username) {
      return null;
    }
    return {
      username,
      role: data['role'],
      schoolName: this.pickSchoolName(data),
      tenantId
    };
  }

}

